module.exports = __webpack_public_path__ + "img/genre7.989a7c80.svg";